export default __webpack_public_path__ + "static/media/support-notes-main-expansion.10ab4b6f.png";